import { FaArrowLeftLong } from 'react-icons/fa6';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import { FILTER_KEYS } from '@/components/app/archive/helpers';
import { useFilterParams } from '@/components/app/archive/helpers/hooks';

import localization from '@/constant/localization';

export default function SeeAllButton() {
  const { updateParams } = useFilterParams({ searchParams: {} });

  const handleSeeAllClick = () => {
    updateParams(FILTER_KEYS.VIEW_DEMO, true);
  };

  return (
    <Container
      role='button'
      onClick={handleSeeAllClick}
      center
      className='cursor-pointer gap-2 text-[#FF9606] transition duration-300 hover:text-[#ff7b01]'
    >
      <Text type={TEXT_TYPE.SPAN} size={SIZE_ENUM.SM} className='font-bold'>
        {localization.viewAll}
      </Text>
      <FaArrowLeftLong />
    </Container>
  );
}
